<template>
  <TabsTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        tabsTriggerVariants({ variant }),
        props.class,
      )
    "
  >
    <span class="tw:truncate">
      <slot />
    </span>
  </TabsTrigger>
</template>

<script setup>
import { reactiveOmit } from '@vueuse/core'
import { TabsTrigger, useForwardProps } from 'reka-ui'
import { cn } from '@/shadcn/lib/utils'
import { tabsTriggerVariants } from './index.js'

const props = defineProps({
  variant: { type: null, required: false },
  value: { type: [String, Number], required: true },
  disabled: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: [String, Object, Function], required: false },
  class: { type: null, required: false },
})

const delegatedProps = reactiveOmit(props, 'class')

const forwardedProps = useForwardProps(delegatedProps)
</script>
